// Sivana mobile menu (snippets/sivana-mobile-menu.liquid): the header's menu button opens this panel
// instead of Horizon's drawer. Sub-screens slide in from the right; Back returns to the main screen.
(() => {
  const menu = document.querySelector('[data-sivana-mnav]');
  if (!menu || menu.dataset.ready) return;
  menu.dataset.ready = 'true';
  const root = menu.querySelector('[data-screen="root"]');
  let trigger = null;

  const showScreen = (name) => {
    menu.querySelectorAll('[data-screen]').forEach((screen) => {
      const active = screen.dataset.screen === name;
      screen.classList.toggle('is-active', active);
      screen.classList.toggle('is-behind', name !== 'root' && screen === root);
      screen.toggleAttribute('hidden', !active && !(name !== 'root' && screen === root));
      screen.setAttribute('aria-hidden', String(!active));
    });
    const active = menu.querySelector(`[data-screen="${name}"]`);
    active?.querySelector('.sivana-mnav__scroll')?.scrollTo(0, 0);
    // Move focus into the new screen for keyboard and screen reader users.
    requestAnimationFrame(() => active?.querySelector('[data-mnav-back], .sivana-mnav__row, a')?.focus({ preventScroll: true }));
  };

  const open = (from) => {
    trigger = from || null;
    showScreen('root');
    document.documentElement.classList.add('sivana-mnav-open');
    menu.classList.remove('is-closing');
    menu.showModal();
    menu.querySelector('[data-mnav-close]')?.blur();
  };

  const close = () => {
    if (!menu.open || menu.classList.contains('is-closing')) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const finish = () => {
      menu.classList.remove('is-closing');
      menu.close();
    };
    if (reduce) finish();
    else {
      menu.classList.add('is-closing');
      setTimeout(finish, 220);
    }
  };

  menu.addEventListener('close', () => {
    document.documentElement.classList.remove('sivana-mnav-open');
    // Leave focus alone when the menu closed to open another panel (search).
    if (!document.querySelector('dialog[open]')) trigger?.focus?.({ preventScroll: true });
  });
  menu.addEventListener('cancel', (event) => {
    event.preventDefault();
    close();
  });
  menu.addEventListener('click', (event) => {
    if (event.target === menu) return close();
    const opener = event.target.closest('[data-mnav-open]');
    if (opener) return showScreen(opener.dataset.mnavOpen);
    if (event.target.closest('[data-mnav-back]')) return showScreen('root');
    if (event.target.closest('[data-mnav-close]')) return close();
    // Following a link: close the menu as the page changes.
    if (event.target.closest('a[href]')) close();
  });

  // The header's menu button (Horizon's drawer toggle) opens this menu instead. Listens on window in the
  // capture phase so it runs before Horizon's own document-level click handling.
  window.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('.header__icon--menu');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const details = button.closest('details');
      if (details) details.open = false;
      open(button);
    },
    true
  );

  window.SivanaMenu = { open, close };
})();
